import { render, staticRenderFns } from "./EditView.vue?vue&type=template&id=5178b897"
import script from "./EditView.vue?vue&type=script&lang=js"
export * from "./EditView.vue?vue&type=script&lang=js"
import style0 from "./EditView.vue?vue&type=style&index=0&id=5178b897&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports